type ShouldKeepScrollPositionOptions = {
    fromLeadId: string | undefined;
    fromPage: unknown;
    pathChanged: boolean;
    toLeadId: string | undefined;
    toPage: unknown;
};

export const shouldKeepScrollPosition = ({
    fromLeadId,
    fromPage,
    pathChanged,
    toLeadId,
    toPage,
}: ShouldKeepScrollPositionOptions) => {
    const staysOnLeadDetails = fromLeadId !== undefined && fromLeadId === toLeadId;
    return (!pathChanged || staysOnLeadDetails) && fromPage === toPage;
};
